import type { FC, Ref } from "react";

import { Button, type ButtonProps } from "./Button";
import { useForm } from "../../hooks/useForm";

export type SubmitButtonProps = Omit<ButtonProps, "type"> & {
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLButtonElement>;
};

/**
 * A submit button that is disabled when the form is disabled.
 */
export const SubmitButton: FC<SubmitButtonProps> = ({
  disabled = false,
  ref,
  ...props
}) => {
  const form = useForm();

  return (
    <Button
      ref={ref}
      type="submit"
      disabled={disabled || form?.disabled}
      {...props}
    />
  );
};
